import { ShardModule } from '../../../shard.module'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ClientRoutingModule } from './client.routing'
import { ClientComponent } from './client.component'
import { SelectClientComponent } from './select-client/select-client.component'
import { NewClientComponent } from './new-client/new-client.component'
import { SelectclientService } from '../../../services/client/selectclient.service'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { CommonsModule } from '../../../commons/commons.module'
import { PipeModule } from '@app/pipes/pipe.module'

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ClientRoutingModule,
        ReactiveFormsModule,
        InfiniteScrollModule,
        A2Edatetimepicker,
        ShardModule,
        CommonsModule,
        PipeModule,
    ],
    declarations: [
        ClientComponent,
        SelectClientComponent,
        NewClientComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    providers: [
        SelectclientService,
    ],
})
export class ClientModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client/client.module.ts